import {
  BASE_BUBBLE_OPACITY,
  NestedBubbleMetadata,
} from '@/components/public/Visualisations/NestedBubbles'
import { Shapes } from '@/components/public/Visualisations/types'
import { PopupDetails } from '@/types'
import Konva from 'konva'

const HIGHLIGHT_OPACITY = 0.2

export class NestedBubbleCircle
  extends Konva.Circle
  implements Shapes.Shape, Shapes.Selectable, Shapes.Highlightable, Shapes.HasPopup
{
  readonly entityName = this.constructor.name
  private _metadata: NestedBubbleMetadata
  private _isHighlighted: boolean = false
  isSelected: boolean = false
  capabilities: Shapes.Capability[] = [
    Shapes.Capability.Selectable,
    Shapes.Capability.Highlightable,
    Shapes.Capability.Focusable,
    Shapes.Capability.Popup,
  ]

  constructor(metadata: NestedBubbleMetadata) {
    super({
      radius: metadata.radius,
      x: metadata.position.x,
      y: metadata.position.y,
      strokeEnabled: false,
    })

    this._metadata = metadata
    this.refresh()
  }

  get key() {
    return this.path.toString()
  }

  get path() {
    return this._metadata.path
  }

  get center() {
    return this.position()
  }

  get left() {
    return this.x() - this.radius()
  }

  get top() {
    return this.y() - this.radius()
  }

  get level() {
    return this._metadata.level
  }

  get isHighlighted() {
    return this._isHighlighted
  }

  set isHighlighted(value: boolean) {
    this._isHighlighted = value
    this.refresh()
  }

  get popupDetails(): PopupDetails {
    return {
      node: this._metadata.visNode,
    }
  }

  get storyColour() {
    return this._metadata.storyColour
  }

  refresh() {
    this.fill(this._fill)
    this.opacity(this._opacity)
  }

  private get _fill() {
    return this.level === 1 ? this.storyColour : 'white'
  }

  private get _opacity() {
    let opacity = this.level === 1 ? 1 : BASE_BUBBLE_OPACITY
    if (this._metadata.isTranslucent) {
      opacity =
        (this._metadata.filterLuminosity / Math.min(this._metadata.maxDisplayLevel - 1, 1)) * 0.01
    }
    if (this.isHighlighted) {
      if (this.level === 1) {
        return 1 - HIGHLIGHT_OPACITY
      }
      return opacity + HIGHLIGHT_OPACITY
    }
    return opacity
  }
}
